import initialState from './../../initialState';

const sortByText = (a, b) => -(a.text < b.text) || +(a.text !== b.text);
const sortByCheckin = (a, b) =>
  -(a.checkin < b.checkin) || +(a.checkin !== b.checkin);

export default (
  state = initialState.registroAcesso,
  { type, value, response }
) => {
  let list, contratantes, contratados;

  switch (type) {
    case 'LIST_ULTIMOS_REGISTROS_ACESSO_SUCCESS':
      return {
        ...state,
        ultimosRegistros: {
          ...state.ultimosRegistros,
          fetching: 2,
          ...response
        }
      };
    case 'CHANGE_DATA_PRESENCA_CONTRATADO':
      return {
        ...state,
        data: {
          ...state.data,
          [value.key]: value.value
        }
      };
    case 'CHECKIN_PRESENCA_CONTRATADO_REQUEST':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          result: [...state.presencas.result, value],
          fetching: 1
          //errors: []
        }
      };
    case 'ENCERRAR_GUIA_INTERATIVO':
      return {
        ...state,
        data: {
          contratante: {
            text: ''
          },
          contratado: {
            nome: '',
            text: '',
            cpf: '',
            empresa: { nome: '' },
            funcao: { nome: '' },
            matricula: '',
            telefone: ''
          }
        }
      };
    case 'CHECKIN_PRESENCA_CONTRATADO_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        data: {
          contratante: {
            text: ''
          },
          contratado: {
            nome: '',
            text: '',
            cpf: '',
            empresa: { nome: '' },
            funcao: { nome: '' },
            matricula: '',
            telefone: ''
          }
        },
        presencas: {
          ...state.presencas,
          result: [...state.presencas.result, value],
          fetching: 2,
          errors: []
        }
      };
    case 'CHECKIN_PRESENCA_CONTRATADO_FAILURE':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          result: state.presencas.result.filter(v => v !== value),
          fetching: 0,
          errors: ['Falha no registro de entrada']
        }
      };
    case 'CHECKIN_PRESENCA_CONTRATADO_INVALID':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          errors: value
        }
      };
    case 'CHECKIN_PRESENCA_CONTRATADO_RETRIEVE_SUCCESS':
      contratantes = [
        ...state.contratantes.result.filter(v => v.id !== value.contratante.id),
        ...Object.values(response.contratantes).map(v => {
          return {
            ...v,
            text: v.apartamento + ' - ' + v.nome
          };
        })
      ].sort(sortByText);
      contratados = [
        ...state.contratados.result.filter(v => v.id !== value.contratado.id),
        ...Object.values(response.contratados).map(contratado => {
          let funcao = response.funcoes[contratado.funcao];
          let empresa = response.empresas[contratado.empresa];

          return {
            ...contratado,
            funcao,
            empresa,
            text:
              contratado.nome +
              ' - ' +
              funcao.nome +
              (empresa.nome ? ' (' + empresa.nome + ')' : '')
          };
        })
      ].sort(sortByText);

      return {
        ...state,
        data: {
          contratante: {
            text: ''
          },
          contratado: {
            nome: '',
            text: '',
            cpf: '',
            empresa: { nome: '' },
            funcao: { nome: '' },
            matricula: '',
            telefone: ''
          }
        },
        contratantes: {
          ...state.contratantes,
          result: contratantes,
          errors: []
        },
        contratados: {
          ...state.contratados,
          result: contratados,
          errors: []
        },
        presencas: {
          ...state.presencas,
          fetching: 2,
          result: [
            ...state.presencas.result.filter(v => v !== value),
            ...Object.values(response.presencas).map(v => {
              let contratante = response.contratantes[v.contratante];
              let contratado = response.contratados[v.contratado];
              let funcao = response.funcoes[contratado.funcao];
              let empresa = response.empresas[contratado.empresa];

              return {
                ...v,
                contratante: {
                  ...contratante,
                  text: contratante.apartamento + ' - ' + contratante.nome
                },
                contratado: {
                  ...contratado,
                  funcao,
                  empresa,
                  text:
                    contratado.nome +
                    ' - ' +
                    funcao.nome +
                    (empresa.nome ? ' (' + empresa.nome + ')' : '')
                }
              };
            })
          ].sort(sortByCheckin),
          errors: []
        }
      };
    case 'CHECKOUT_PRESENCA_CONTRATADO_REQUEST':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          result: state.presencas.result.filter(v => v !== value),
          fetching: 1
          //errors: []
        }
      };
    case 'CHECKOUT_PRESENCA_CONTRATADO_FAILURE':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          result: [...state.presencas.result, value],
          fetching: 0,
          errors: ['Falha no registro de saída']
        }
      };
    case 'CHECKOUT_PRESENCA_CONTRATADO_SUCCESS':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          fetching: 2,
          result: state.presencas.result.filter(v => v !== value),
          errors: []
        }
      };
    case 'LIST_PRESENCA_CONTRATADO_REQUEST':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          fetching: 1
        }
      };
    case 'LIST_PRESENCA_CONTRATADO_SUCCESS':
      list = Object.values(response.presencas);
      //contratados = Object.values(response.contratados);
      //contratantes = Object.values(response.contratantes);

      return {
        ...state,
        /*contratados: {
                    ...state.contratados,
                    result: [
                        ...state.contratados.result.filter(v => !contratados.some(r => r.id === v.id)),
                        ...contratados
                    ].sort(sortByText),
                    errors: []
                },
                contratantes: {
                    ...state.contratantes,
                    result: [
                        ...state.contratantes.result.filter(v => !contratantes.some(r => r.id === v.id)),
                        ...contratantes
                    ].sort(sortByText),
                    errors: []
                },*/
        presencas: {
          result: list
            .map(v => {
              let contratante = response.contratantes[v.contratante];
              let contratado = response.contratados[v.contratado];
              let funcao = response.funcoes[contratado.funcao];
              let empresa = response.empresas[contratado.empresa];

              return {
                ...v,
                contratante: {
                  ...contratante,
                  text: contratante.apartamento + ' - ' + contratante.nome
                },
                contratado: {
                  ...contratado,
                  funcao,
                  empresa,
                  text:
                    contratado.nome +
                    ' - ' +
                    funcao.nome +
                    (empresa.nome ? ' (' + empresa.nome + ')' : '')
                }
              };
            })
            .sort(sortByCheckin),
          fetching: 2,
          errors: []
        }
      };
    case 'LIST_PRESENCA_CONTRATADO_FAILURE':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          fetching: 0,
          errors: ['Falha na obtenção da lista']
        }
      };
    case 'LIST_CONTRATANTES_REQUEST':
      return {
        ...state,
        contratantes: {
          ...state.contratantes,
          fetching: 1
          //errors: []
        }
      };
    case 'LIST_CONTRATANTES_SUCCESS':
      list = Object.values(response.contratantes);

      return {
        ...state,
        contratantes: {
          ...state.contratantes,
          fetching: 2,
          result: [
            ...state.contratantes.result.filter(
              v => !list.some(r => r.id === v.id)
            ),
            ...list.map(v => ({
              ...v,
              text: v.apartamento + ' - ' + v.nome
            }))
          ].sort(sortByText),
          errors: []
        }
      };
    case 'LIST_CONTRATANTES_FAILURE':
      return {
        ...state,
        contratantes: {
          ...state.contratantes,
          fetching: 0,
          errors: ['Falha na obtenção da lista']
        }
      };
    case 'LIST_CONTRATADOS_REQUEST':
      return {
        ...state,
        contratados: {
          ...state.contratados,
          fetching: 1
          //errors: []
        }
      };
    case 'LIST_CONTRATADOS_SUCCESS':
      list = Object.values(response.contratados);

      return {
        ...state,
        contratados: {
          ...state.contratados,
          fetching: 2,
          result: [
            ...state.contratados.result.filter(
              v => !list.some(r => r.id === v.id)
            ),
            ...list.map(v => {
              v.funcao = response.funcoes[v.funcao];
              v.empresa = response.empresas[v.empresa];

              return {
                ...v,
                text:
                  v.nome +
                  (v.funcao.nome ? ' - ' + v.funcao.nome : '') +
                  (v.empresa.nome ? ' (' + v.empresa.nome + ')' : '')
              };
            })
          ].sort(sortByText),
          errors: []
        }
      };
    case 'LIST_CONTRATADOS_FAILURE':
      return {
        ...state,
        contratados: {
          ...state.contratados,
          fetching: 0,
          errors: ['Falha na obtenção da lista']
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/reducer.js